import { useState } from "react"

const PAGE_SIZE = 10

export type UsePaginationProps = {
  pageSize?: number
  page?: number
}

export default function usePagination(props?: UsePaginationProps) {
  const { pageSize: initialPageSize = PAGE_SIZE, page: initialPage = 0 } =
    props || {}

  const getInitialPage = () => initialPage
  const [page, setPage] = useState<number>(getInitialPage)
  const changePage = (newPage: number) => setPage(newPage)
  const resetPage = () => setPage(getInitialPage)

  const getInitialPageSize = () => initialPageSize
  const [pageSize, setPageSize] = useState<number>(getInitialPageSize)
  const changePageSize = (newSize: number | string) => {
    setPageSize(+newSize)
    resetPage()
  }
  const resetPageSize = () => {
    setPageSize(getInitialPageSize)
    resetPage()
  }

  const reset = () => {
    resetPage()
    resetPageSize()
  }

  const limit = pageSize
  const offset = page * pageSize

  return {
    page,
    pageSize,
    limit,
    offset,
    //
    changePage,
    resetPage,
    changePageSize,
    resetPageSize,
    reset,
  }
}
